export default __webpack_public_path__ + "e178d7377f095fd0a4f38f7e4f2dd25a.svg";